<template>
  <div class="content">
    <div class="box">
      <div class="search">
        <div style="display: flex;align-items: center">
          <div style="cursor: pointer" @click="goBack"><img src="../../../assets/image/back.png"></div>
          <div style="display: flex;align-items: center">
            <p style="width: 4vw;font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;">姓名</p>
            <el-input v-model="userName" clearable @change="getData" size="small" placeholder="请输入姓名"></el-input>
          </div>
          <div style="display: flex;align-items: center">
            <p style="width: 4vw;font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;">名称</p>
            <el-input v-model="projectName" clearable @change="getData" size="small" placeholder="请输入单位名称"></el-input>
          </div>
          <div style="display: flex;align-items: center;margin-right: 10px">
            <p style="width: 4vw;
            font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;">类型</p>
            <el-select size="small" v-model="qualifiedFlag" @change="getData">
              <el-option
                label="默认"
                value="">
              </el-option>
              <el-option
                label="通过"
                value="1">
              </el-option>
              <el-option
                label="未通过"
                value="0">
              </el-option>
            </el-select>
          </div>
          <span class="button" @click="getData">查询</span>
        </div>
        <div style="display:flex;">
          <span class="button" style="margin-right:8px" @click="downloadExamStatisTemplate">下载模板</span>
          <el-upload
                  ref="upload"
                  action="https://sites.tongsheng01.com/paper/importExamStatis"
                  :headers="uploadHead"
                  :data="uploadData"
                  :on-success="success"
                  :show-file-list="false">
                <span class="button" style="margin-right:8px" >导入</span>
              </el-upload>
        <span class="button" @click="exportExamPerosnDetail">导出</span>
        </div>
      </div>
      <el-table height="76vh"
      :data="list"
      :header-cell-style="{height:'48px',color:'#909399'}">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            <span>{{(pageNum-1)*pageSize+scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column label="单位名称">
          <template slot-scope="scope">
            <span>{{scope.row.projectName}}</span>
          </template>
        </el-table-column>
         <el-table-column label="姓名">
          <template slot-scope="scope">
             <span>{{scope.row.personName}}</span>
          </template>
        </el-table-column>
         <el-table-column label="状态">
          <template slot-scope="scope">
            <span>{{scope.row.signFlag==0?'未考':scope.row.handFlag==1?'已交卷':'未交卷'}}</span>
          </template>
        </el-table-column>
         <el-table-column label="开始时间">
          <template slot-scope="scope">
            <span>{{scope.row.signTime}}</span>
          </template>
        </el-table-column>
         <el-table-column label="结束时间">
          <template slot-scope="scope">
            <span>{{scope.row.handTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试时长">
          <template slot-scope="scope">
            <span>{{scope.row.dateSpan}}</span>
          </template>
        </el-table-column>
        <el-table-column label="得分">
          <template slot-scope="scope">
            <span>{{scope.row.examScore}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否通过">
          <template slot-scope="scope">
            <span>{{scope.row.qualifiedFlag==0?'未通过':'通过'}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      <el-dialog
      title="错误提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>{{msg}}</span>
      <span>{{msgData}}</span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        data:{},
        pageNum:1,
        pageSize:20,
        total:0,
        userName:'',
        projectName:'',
        list:[],
        qualifiedFlag:'',
        uploadHead: {
          accessToken: util.session.get('token')
        },
        uploadData: {
          projectId:util.session.get('groupId'),
          paperId:'',
        },
        msg:'',
        dialogVisible:false,
        msgData:'',
      }
    },
    mounted(){
      this.data = JSON.parse(this.$route.query.data)
      this.getData()
    },
    methods: {
      success(val){
         if(val.code==200){
          this.getData()
          this.$message({
            type:'success',
            message:val.msg
          })
        }else{
          this.dialogVisible=true
          this.msg = val.msg
          if(val.data){
            this.msgData = val.data
          }
        }
      },
      handleSizeChange(val){
        this.pageSize = val
        this.pageNum = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.pageNum = val
        this.getData()
      },
      getData(){
        myHttp.examPerosnDetail({
          paperId:this.data.id,
          userName:this.userName,
          projectName:this.projectName,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          qualifiedFlag:this.qualifiedFlag
        }).then(res=>{
          console.log(res)
          this.list = res.data.list
          this.total = res.data.total
          this.uploadData.paperId=this.data.id
        })
      },
          /**导出列表 */
    exportExamPerosnDetail(){
      var token = util.session.get('token')
      console.log(token)
      window.open(myHttp.exportExamPerosnDetail+'?paperId='+this.data.id+'&userName='+this.userName+'&projectName='+this.projectName+'&pageNum='+this.pageNum+'&pageSize='+this.pageSize+'&qualifiedFlag='+this.qualifiedFlag+'&accessToken='+token)
    },
    downloadExamStatisTemplate(){
      var token = util.session.get('token')
      window.open(myHttp.downloadExamStatisTemplate+'?accessToken='+token)
    },
      goBack(){
        this.$router.go(-1)
      }
    },
  }
</script>

<style scoped>
.button{
  display: inline-block;
  width: 80px;
  height: 32px;
  border-radius: 6px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid #999999;
  font-size: 14px;
  color: #666;
  text-align: center;
  line-height: 32px;
  cursor: pointer;
}
.button:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.content{
  padding: 1vh 1vw;
}
.box{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.search{
  padding: 12px 18px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #D8D8D8;
}
.content >>> .el-pagination{
  border-radius: 0 0 6px 6px;
}
::v-deep.el-table th.el-table__cell>.cell{
    font-family: SourceHanSansCN-Regular;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #909399
}
::v-deep.el-table td.el-table__cell div{
font-family: SourceHanSansCN-Normal;
font-size: 14px;
font-weight: 350;
letter-spacing: 0em;
color: #666666;
}
</style>